<template>
    <h1 class="text-3xl font-bold text-gray-900">
        {{ first }} <span class="font-normal px-2">|</span>
        <span class="font-normal">{{ second }}</span>
    </h1>
    <Breadcrumb :pages="pages" />
</template>

<script>
import Breadcrumb from "./Breadcrumb";

export default {
    name: "PipedTitle",
    components: {
        Breadcrumb,
    },
    props: {
        first: {
            type: String,
            required: true,
        },
        second: {
            type: String,
            required: false,
        },
        pages: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style scoped></style>
